module.exports = __webpack_public_path__ + "static/media/icon_add-data.ae149c1a.svg";